import Button from "components/common/Button/Button";
import Disabled from "components/common/Disabled";
import LabelStat from "components/common/LabelStat";
import PinInput from "components/common/PinInput/index";
import Text from "components/common/Text/Text";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import Loader from "react-loader-spinner";
import strings from "static/strings.js";
import styled from "styled-components";
import theme from "themes/simple-theme";
import titleCase from "utils/format";
interface IProps {
  budtenderId: string;
  goodPin?: boolean;
  wrongPin?: boolean;

  className?: string;
  total?: number;
  redeeming?: boolean;
  redeem(): any;
}

const Footer = styled(
  ({
    budtenderId,
    className,
    total,
    redeem,
    goodPin,
    wrongPin,
    redeeming
  }: IProps) => {
    const pin = "﹡﹡﹡﹡".slice(0, (budtenderId || "").length);

    return (
      <Row className={className} align="end">
        <Col md={12} align="end">
          <TotalPoints black label="Final Total:" value={total} />
        </Col>
        <Col md={12} align="end">
          <FooterPinInput pin={pin} goodPin={goodPin} wrongPin={wrongPin} />
          <Disabled isDisabled={!goodPin}>
            {redeeming ? (
              <div
                style={{
                  padding: "0px 62px"
                }}
              >
                <Loader
                  type="ThreeDots"
                  color={theme.color.primary}
                  height={60}
                  width={80}
                />
              </div>
            ) : (
              <Button onClick={redeem} primary disabled={!goodPin}>
                Confirm Transaction
              </Button>
            )}
          </Disabled>
        </Col>
      </Row>
    );
  }
)`
  margin-top: 40px;
  padding-top: 25px;
`;

interface IFooterPinInput {
  pin: string;
  className?: string;
  goodPin?: boolean;
  wrongPin?: boolean;
}
const FooterPinInput = styled(
  ({ pin, className, goodPin, wrongPin }: IFooterPinInput) => (
    <div className={className}>
      <Text alternate>{titleCase(strings.cashier)} ID</Text>
      <div style={{ marginTop: 10 }}>
        <PinInput
          pin={pin}
          small
          focused
          goodPin={goodPin}
          wrongPin={wrongPin}
        />
      </div>
    </div>
  )
)`
  text-align: center;
  margin-right: 60px;
  min-width: 210px;
  display: inline-block;
  vertical-align: bottom;
`;

const TotalPoints = styled(LabelStat)`
  /* margin-top: 40px; */
  padding-bottom: 40px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${theme.color.primary};
`;

export default Footer;



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/RedeemConfirmation/Footer.tsx